/**
 * Checks whether a given value is a not null object and can be treated as a record.
 * @param value - The value to check.
 * @returns `true` if the value is a non-null object, otherwise `false`.
 */
const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

/**
 * Retrieves the value of a nested property from an object using a dot-separated path string.
 * If any part of the path does not exist, `undefined` is returned.
 * @param obj - The object from which to retrieve the value.
 * @param path - Dot-separated string representing the path to the nested property (e.g., "a.b.c").
 * @returns The value at the specified path, or initial path if the path does not exist.
 */
export function getObjectValueByPath(obj: object, path: string) {
  if (!obj) return path;

  const keys = path.split('.');
  let target: unknown = obj;

  for (const key of keys) {
    if (!isRecord(target) || !(key in target)) {
      return path;
    }
    target = target[key];
  }

  return target ?? path;
}
